import styled from 'styled-components';

// =============================================================================
// MAIN TOOLTIP WRAPPER (For Floating UI positioned tooltips)
// =============================================================================

export const StyledTooltipWrapper = styled.div<{
    $isVertical?: boolean;
    $gap?: number;
}>`
    z-index: 1000000000;
    display: flex;
    flex-direction: ${({ $isVertical }) => ($isVertical ? 'column' : 'row')};
    gap: ${({ $gap = 0 }) => `${$gap}px`};
`;

// =============================================================================
// CURSOR TOOLTIP WRAPPER (For cursor-following mode)
// =============================================================================

export const StyledCursorTooltipWrapper = styled.div<{ $gap?: number }>`
    z-index: 1000000000;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    gap: ${({ $gap = 0 }) => `${$gap}px`};
`;

// =============================================================================
// TOOLTIP CONTENT (Individual content block)
// =============================================================================

export const StyledTooltipContent = styled.div<{
    $bgColor: string;
    $textColor: string;
    $borderRadius?: string;
    $order?: number;
}>`
    background-color: ${({ $bgColor }) => $bgColor};
    color: ${({ $textColor }) => $textColor};
    border-radius: ${({ $borderRadius = '0.8rem' }) => $borderRadius};
    position: relative;
    ${({ $order }) => $order !== undefined && `order: ${$order};`}
`;

// =============================================================================
// INLINE WRAPPER (For reference element)
// =============================================================================

export const StyledInlineWrapper = styled.div<{ $display?: 'inline-block' | 'block' | 'contents' }>`
    display: ${({ $display = 'inline-block' }) => $display};
`;
